import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { isDefined, isNil } from "@clipboard-health/util-ts";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import {
  APP_V2_APP_EVENTS,
  APP_V2_USER_EVENTS,
  logError,
  logEvent,
} from "@src/appV2/lib/analytics";
import { useArrivalTimeConfig } from "@src/appV2/redesign/ArrivalTime/useArrivalTimeConfig";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { ListLoadingState } from "../../../components/ListLoadingState";
import { PageWrapper } from "../../../components/PageWrapper";
import { PageContent } from "../../../WorkerShifts/components/PageContent";
import { ClipboardScoreError } from "../ClipboardScoreError";
import { ClipboardScoreAdjustmentsContent } from "./Content";
import { ClipboardScoreAdjustmentsHeader } from "./Header";

export function ClipboardScoreAdjustments() {
  const { userId } = useDefinedWorker();
  const {
    data: clipboardScoreProfile,
    isLoading: isClipboardScoreProfileLoading,
    refetch: refetchClipboardScoreProfile,
    isError: isClipboardScoreProfileError,
    error: clipboardScoreProfileError,
  } = useGetClipboardScoreProfile(userId, {
    enabled: isDefined(userId),
  });

  const { useExpectedArrivalTime } = useArrivalTimeConfig();

  if (isClipboardScoreProfileLoading) {
    return <ListLoadingState texts={["Loading score adjustments..."]} />;
  }

  if (isClipboardScoreProfileError || isNil(clipboardScoreProfile)) {
    logError(APP_V2_APP_EVENTS.CLIPBOARD_SCORE_PROFILE_ERROR, {
      error: clipboardScoreProfileError,
      metadata: { workerId: userId },
    });
    return (
      <ClipboardScoreError
        title="Error loading score adjustments"
        onRefresh={refetchClipboardScoreProfile}
      />
    );
  }

  logEvent(APP_V2_USER_EVENTS.CLIPBOARD_SCORE_ADJUSTMENTS_VIEWED, {
    workerId: userId,
  });

  const { policy, clipboardScorePenaltyMultipliers: multipliers } = clipboardScoreProfile;

  return (
    <PageWrapper variant="tertiary">
      <PageHeaderWrapper variant="tertiary">
        <ClipboardScoreAdjustmentsHeader />
      </PageHeaderWrapper>
      <PageContent sx={{ paddingBottom: 11 }}>
        <ClipboardScoreAdjustmentsContent
          policy={policy}
          multipliers={multipliers}
          useExpectedArrivalTime={useExpectedArrivalTime}
        />
      </PageContent>
    </PageWrapper>
  );
}
